import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { doc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../context/UserContext';
import { IoStar, IoStarOutline, IoStarHalf } from 'react-icons/io5';
import './StarRating.css';

export default function StarRating({ bookId, ratings = {}, interactive = true, size = 'md' }) {
  const { user } = useUser();
  const [hovered, setHovered] = useState(0);

  // Calculer la moyenne
  const allRatings = Object.values(ratings);
  const average = allRatings.length > 0
    ? allRatings.reduce((sum, r) => sum + r, 0) / allRatings.length
    : 0;
  const userRating = user && ratings[user.id] ? ratings[user.id] : 0;

  const handleRate = async (value) => {
    if (!interactive || !user || !bookId) return;
    const bookRef = doc(db, 'books', bookId);
    await updateDoc(bookRef, {
      ['ratings.' + user.id]: value,
    });
  };

  const displayValue = hovered || userRating || average;

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      const filled = displayValue >= i;
      const half = displayValue >= i - 0.5 && displayValue < i;

      stars.push(
        <motion.button
          key={i}
          className={'star-btn star-btn-' + size}
          onClick={() => handleRate(i)}
          onMouseEnter={() => interactive && setHovered(i)}
          onMouseLeave={() => setHovered(0)}
          whileTap={interactive ? { scale: 0.8 } : {}}
          style={{ cursor: interactive ? 'pointer' : 'default' }}
        >
          {filled ? (
            <IoStar className="star-filled" />
          ) : half ? (
            <IoStarHalf className="star-filled" />
          ) : (
            <IoStarOutline className="star-empty" />
          )}
        </motion.button>
      );
    }
    return stars;
  };

  return (
    <div className="star-rating">
      <div className="star-rating-stars">{renderStars()}</div>
      {allRatings.length > 0 && (
        <span className="star-rating-info">
          {average.toFixed(1)} ({allRatings.length})
        </span>
      )}
    </div>
  );
}